export const CATEGORIES = {
    GIFT: 'cat60270'
};
